import React, { ReactNode } from 'react'
import Image from 'next/image'
import LinkedText from './LinkedText'
import { LinkedContent } from '@/utils/ui/types/linked-content'

interface FeatureCardProps {
  mainHeading: string
  subHeading: string | LinkedContent
  screenshot: string
  orientation: 'left' | 'right'
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  mainHeading,
  subHeading,
  screenshot,
  orientation,
}) => {
  // Render the subHeading content based on its type
  const renderSubHeading = (): ReactNode => {
    if (typeof subHeading === 'string') {
      return subHeading
    }

    if (subHeading && typeof subHeading === 'object') {
      // Check if it has part1, link1, etc. structure
      const keys = Object.keys(subHeading)
      const hasStructuredLinks = keys.some((key) =>
        key.match(/^(part|link)\d+$/)
      )

      if (hasStructuredLinks) {
        return <LinkedText content={subHeading} />
      }
    }

    // Fallback
    return String(subHeading)
  }

  return (
    <div className='flex flex-col items-center justify-between gap-8 md:flex-row'>
      {orientation === 'left' && (
        <div className='w-full md:w-1/2'>
          <Image src={screenshot} alt={mainHeading} width={500} height={500} />
        </div>
      )}
      <div className='w-full text-center md:w-1/2 md:text-left'>
        <h2 className='mb-4 text-2xl font-bold md:text-3xl'>{mainHeading}</h2>
        <p className='text-lg md:text-xl'>{renderSubHeading()}</p>
      </div>
      {orientation === 'right' && (
        <div className='w-full md:w-1/2'>
          <Image src={screenshot} alt={mainHeading} width={500} height={300} />
        </div>
      )}
    </div>
  )
}

export default FeatureCard
